import Reveal from "@/components/base/Reveal";
import type { ScheduleDay } from "@/mocks/schedule";

interface TimetableProps {
  schedule: ScheduleDay[];
}

export default function Timetable({ schedule }: TimetableProps) {
  return (
    <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {schedule.map((day, idx) => (
        <Reveal key={day.day} delay={idx * 60}>
          <article className="h-full overflow-hidden rounded-2xl border border-background-200 bg-background-50">
            <div className="flex items-center justify-between bg-primary-500 px-5 py-3.5">
              <span className="font-heading text-base font-black text-foreground-950">
                {day.day}요일
              </span>
              <span className="font-label text-[10px] tracking-[0.15em] text-foreground-950/60">
                {day.slots.length}개 반
              </span>
            </div>
            <div className="divide-y divide-background-200">
              {day.slots.map((slot) => (
                <div
                  key={`${day.day}-${slot.time}`}
                  className="flex items-center justify-between gap-3 px-5 py-4"
                >
                  <span className="font-label text-xs text-foreground-600">{slot.time}</span>
                  <span className="text-right text-sm font-bold text-foreground-950">
                    {slot.name}
                  </span>
                </div>
              ))}
            </div>
          </article>
        </Reveal>
      ))}
    </div>
  );
}